import { CONSTELLATIONS, BG_STARS } from "@/lib/sky";

function Constellation({ c, section, idx }) {
  const lit = section.done ? c.stars.length : Math.floor((section.filled / section.goal) * c.stars.length);
  const seg = c.stars.map((s, i) => [s, c.stars[(i + 1) % c.stars.length], i]).filter(([, , i]) => (c.closed || i < c.stars.length - 1));
  return (
    <g data-testid={`sky-constellation-${idx}`} className={section.done ? "sky-done" : ""}>
      {seg.map(([a, b, i]) => {
        const on = section.done || (i + 1 < lit);
        return <line key={i} x1={a[0]} y1={a[1]} x2={b[0]} y2={b[1]} stroke={on ? "#fde68a" : "#ffffff"} strokeOpacity={on ? 0.8 : 0.08} strokeWidth={on ? 2 : 1} strokeDasharray={on ? "" : "4 6"} />;
      })}
      {c.stars.map(([x, y], i) => (
        <g key={i}>
          {i < lit && <circle cx={x} cy={y} r="14" fill="url(#sky-glow)" className="sky-twinkle" style={{ animationDelay: `${(i * 0.37) % 2}s` }} />}
          <circle cx={x} cy={y} r={i < lit ? 5 : 3} fill={i < lit ? "#fffbeb" : "#ffffff"} fillOpacity={i < lit ? 1 : 0.18} />
        </g>
      ))}
    </g>
  );
}

export function SkyCanvas({ sky, onStar, selected, meId }) {
  return (
    <svg viewBox="0 0 1000 620" className="w-full h-auto block" role="img" aria-label="Sternenhimmel" data-testid="sky-canvas">
      <defs>
        <radialGradient id="sky-glow"><stop offset="0%" stopColor="#fde68a" stopOpacity=".9" /><stop offset="100%" stopColor="#f472b6" stopOpacity="0" /></radialGradient>
        <linearGradient id="sky-shoot" x1="0" x2="1"><stop offset="0%" stopColor="#fff" stopOpacity="0" /><stop offset="100%" stopColor="#fde68a" /></linearGradient>
      </defs>
      {BG_STARS.map(([x, y, r], i) => <circle key={i} cx={x} cy={y} r={r} fill="#fff" fillOpacity=".35" className="sky-twinkle" style={{ animationDelay: `${(i % 7) * 0.5}s` }} />)}
      {sky.boost_until && [0, 1, 2].map((i) => <line key={`s${i}`} x1="0" y1="0" x2="120" y2="0" stroke="url(#sky-shoot)" strokeWidth="3" strokeLinecap="round" className="sky-shooting" style={{ animationDelay: `${i * 1.3}s`, "--sy": `${60 + i * 140}px` }} />)}
      {(sky.stars || []).map((s) => {
        const mine = s.user_id === meId;
        const r = Math.min(7, 2.5 + Math.sqrt(s.amount) / 8);
        return (
          <g key={s.user_id} onClick={() => onStar?.(s)} className="cursor-pointer" data-testid={`sky-star-${s.user_id}`}>
            <circle cx={s.x} cy={s.y} r="16" fill="transparent" />
            {(mine || selected === s.user_id) && <circle cx={s.x} cy={s.y} r={r + 6} fill="none" stroke={mine ? "#fde68a" : "#f9a8d4"} strokeWidth="1.5" className="sky-twinkle" />}
            <circle cx={s.x} cy={s.y} r={r} fill={mine ? "#fde68a" : "#fbcfe8"} className="sky-twinkle" style={{ animationDelay: `${(s.x % 9) * 0.3}s` }} />
          </g>
        );
      })}
      {CONSTELLATIONS.map((c, i) => <Constellation key={i} c={c} section={sky.sections[i]} idx={i} />)}
      {CONSTELLATIONS.map((c, i) => {
        const xs = c.stars.map((s) => s[0]), ys = c.stars.map((s) => s[1]);
        return <text key={`t${i}`} x={(Math.min(...xs) + Math.max(...xs)) / 2} y={Math.max(...ys) + 34} textAnchor="middle" fill={sky.sections[i].done ? "#fde68a" : "#fbcfe8"} fillOpacity={sky.sections[i].done ? 1 : 0.85} fontSize="24" fontWeight="800">{sky.sections[i].name}{sky.sections[i].done ? " ✦" : ""}</text>;
      })}
    </svg>
  );
}
